import React from 'react';

import { useDispatch } from 'react-redux';

import { MANUALLY_TRANSFER } from 'components/Pages/Admin/GuestPortal/Flights/AddManually/utils';
import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormTitle from 'components/shared/Typography/FormTitle';
import { openModalAction } from 'store/modal';

export function WhatAdd({ itemIndex }) {
  const dispatch = useDispatch();

  return (
    <div>
      <FormTitle center>What would you like to add?</FormTitle>
      <FormActions isCenter>
        <Button
          type="default"
          onClick={() => {
            dispatch(
              openModalAction({
                type: 'ADD_FLIGHTS',
                data: { itemIndex },
              }),
            );
          }}
        >
          Flight
        </Button>

        <Button
          type="default"
          onClick={() => {
            dispatch(
              openModalAction({
                type: 'ADD_MANUALLY',
                data: { itemIndex, formType: MANUALLY_TRANSFER },
              }),
            );
          }}
        >
          Transfer
        </Button>
      </FormActions>
    </div>
  );
}
